import { useMemo } from 'react';

import {
	getIsAdmin,
	getIsNav4TenantOptIn,
} from '@atlassian/jira-navigation-apps-sidebar-nav4-get-user-meta/src/index.tsx';
import { getWillShowNav4TenantOptIn } from '@atlassian/jira-navigation-apps-sidebar-nav4-rollout-core/src/common/utils/get-will-show-nav4-tenant-opt-in/index.tsx';
import { fg } from '@atlassian/jira-feature-gating';

export const useShowBenefitsModalV2 = () => {
	const isEligible = useMemo(() => {
		if (!fg('jira_nav4_benefits_modal_v2')) return false;

		// Bail early for non-admin users.
		if (!getIsAdmin()) return false;

		// If the tenant has already been opted in, we don't need to sell them the benefits again
		if (getIsNav4TenantOptIn()) return false;

		// Show the modal to admins who can opt the tenant in
		return getWillShowNav4TenantOptIn();
	}, []);

	return { isEligible };
};
